export default "__VITE_ASSET__fmg1x0CP__"